import { MailIcon } from "@/components/icons";
import { sendSlsEvent } from "@/hooks/useAnalytics";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";

const EmailLoginBtn = ({ goEmailLogin }: { goEmailLogin: () => void }) => {
  const { t } = useTranslation();
  const router = useRouter();
  const code = router?.query?.code as string;

  return (
    <div
      onClick={() => {
        sendSlsEvent({
          UM_Key_EventName: "UM_Event_ModularClick",
          UM_Key_ButtonName: "continuewithmail",
          UM_Key_PageName: "HalfLaunchPage_web",
          UM_Key_UserType: "Guest",
          UM_Key_SourcePage: router.route,
          UM_Key_ResourceID: code,
        });
        goEmailLogin();
      }}
      style={{
        width: "100%",
        fontFamily: "Mulish",
        fontWeight: "700",
        fontSize: "16px",
        color: "#333",
        backgroundColor: "#f2f2f4",
        borderRadius: "8px",
        border: "1px solid #f2f2f2",
        height: "56px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <MailIcon></MailIcon>
      <span className="ms-[8px]"> {t("login.continueWithEmail")}</span>
    </div>
  );
};

export default EmailLoginBtn;
